import { FilterStatus } from '../../../init/proto_client';

export const filterStatusMap = {
  [FilterStatus.DROPPED]: 'Drop off',
  [FilterStatus.FINISH]: 'Finished',
  [FilterStatus.ACTIVE]: 'Active',
  [FilterStatus.NOT_SETUP]: 'Not setup yet',
  [FilterStatus.PENDING]: 'Pending',
};
